import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { BasePaginationService } from '@components/pagination/pagination.type'
import { CompaniesPaginatedGQL, CompaniesPaginatedQuery, CompanyOrderByInput, PageInfo } from '@generated/sammathnaur.graphql'
import { Subject, firstValueFrom } from 'rxjs'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class CompaniesService implements BasePaginationService {

  public search$: Subject<void> = new Subject()

  public readonly filterForm = new FormGroup({
    nameContains: new FormControl(''),
    archived: new FormControl(false as 'all' | false | true)
  })

  public orderBy = signal<CompanyOrderByInput>(CompanyOrderByInput.NameAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)
  public totalCount = signal<number>(0)
  public pageInfo = signal<PageInfo | undefined>(undefined)
  public isLoading = signal<boolean>(false)

  private readonly companiesPageGQL = inject(CompaniesPaginatedGQL)

  public async searchPage(): Promise<Apollo.QueryResult<CompaniesPaginatedQuery>> {
    const { nameContains, archived } = this.filterForm.value

    const observable$ = this.companiesPageGQL.fetch({
      variables: {
        where: {
          name_contains: nameContains,
          archived: archived === 'all' ? undefined : archived,
        },
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }
}
